import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    width: 'calc(100% - 300px)',
    height: 'calc(100vh - 64px)',
    float: 'right',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      float: 'none',
      position: 'relative',
      overflowY: 'initial',
    },
    '@media print': {
      height: 'inherit',
    },
  },
}));

export default useStyles;
